import React from "react";

// Subtle animated circuit-board SVG layer for section backgrounds.
export const CircuitBackground = ({ className = "" }) => (
  <div className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`} aria-hidden>
    <svg className="h-full w-full" viewBox="0 0 1200 700" fill="none" preserveAspectRatio="xMidYMid slice">
      <defs>
        <linearGradient id="wire" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%" stopColor="#70d6ff" stopOpacity="0" />
          <stop offset="50%" stopColor="#7fe8ff" stopOpacity="0.9" />
          <stop offset="100%" stopColor="#70d6ff" stopOpacity="0" />
        </linearGradient>
      </defs>
      <g stroke="#50aee5" strokeOpacity="0.10" strokeWidth="1.2" fill="none">
        <path d="M0 120 H320 V260 H620 V120 H1200" />
        <path d="M0 340 H180 V480 H520 V340 H900 V520 H1200" />
        <path d="M0 580 H420 V440 H760 V600 H1200" />
        <path d="M600 0 V180 H860 V420" />
        <path d="M160 700 V520 H300 V360" />
      </g>
      <g fill="#70d6ff" fillOpacity="0.35">
        {[[320,120],[620,260],[180,340],[520,480],[900,340],[860,180],[300,520],[420,440],[760,600]].map(([cx,cy],i)=>(
          <circle key={i} cx={cx} cy={cy} r="3.2" />
        ))}
      </g>
      {[
        "M0 120 H320 V260 H620 V120 H1200",
        "M0 340 H180 V480 H520 V340 H900 V520 H1200",
      ].map((d, i) => (
        <path key={i} d={d} stroke="url(#wire)" strokeWidth="2" strokeLinecap="round"
          strokeDasharray="140 900" style={{ animation: `dash 6s linear ${i * 2}s infinite` }} />
      ))}
    </svg>
    <style>{`@keyframes dash { from { stroke-dashoffset: 1040; } to { stroke-dashoffset: 0; } }`}</style>
  </div>
);

// Floating luminous particles (lightweight).
export const Particles = ({ count = 14, className = "" }) => {
  const dots = React.useMemo(
    () => Array.from({ length: count }, (_, i) => ({
      left: Math.random() * 100,
      top: Math.random() * 100,
      size: Math.random() * 2.4 + 1.2,
      dur: Math.random() * 5 + 7,
      delay: Math.random() * 6,
      op: Math.random() * 0.4 + 0.2,
    })), [count]
  );
  return (
    <div className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`} aria-hidden>
      {dots.map((d, i) => (
        <span key={i} className="absolute rounded-full bg-glow-3"
          style={{
            left: `${d.left}%`, top: `${d.top}%`, width: d.size, height: d.size, opacity: d.op,
            boxShadow: "0 0 6px 1px rgba(127,232,255,0.5)",
            willChange: "transform",
            animation: `floatDot ${d.dur}s ease-in-out ${d.delay}s infinite`,
          }} />
      ))}
      <style>{`@keyframes floatDot { 0%,100% { transform: translateY(0) } 50% { transform: translateY(-22px) } }`}</style>
    </div>
  );
};
